import Head from "next/head";
import dynamic from 'next/dynamic';
// import LayoutPayment from "../../components/layout/LayoutPayment";
import PaymentContext from "../../store/PaymentContext";
// import EmptyCart from "../../components/Cart/EmptyCart";
import { useContext, useEffect, useState } from "react";
import { Spin } from "antd";
// import PaymentSuccess from "../../components/Cart/PaymentSuccess";
import { useRouter } from "next/router";
import { IProductDetailPayment } from "../../@types/IProduct/IProductDetail";
const DynamicLayoutPayment = dynamic(() => import('../../components/layout/LayoutPayment'));
const DynamicEmptyCart = dynamic(() => import('../../components/Cart/EmptyCart'));
const DynamicPaymentSuccess = dynamic(() => import('../../components/Cart/PaymentSuccess'));

const OrderSuccess = () => {
    const router = useRouter();
    const {
        sellCarts,
        rentCarts,
        spinLoading,
        setCurrentStep,
        setRentTransportFee,
        setSellTransportFee,
        setRentCarts, setSellCarts, orderSuccess
    } = useContext(PaymentContext);

    const [firstLoad, setFirstLoad] = useState(true);

    useEffect(() => {
        handleCheckDataCart();
        setFirstLoad(false)
    }, [])

    useEffect(() => {
        if (!firstLoad) {
            window.addEventListener("beforeunload", reloadPage);
        }
        return () => {
            if (!firstLoad) {
                window.removeEventListener("beforeunload", reloadPage);
                reloadPage();
            }
        }
    }, [firstLoad])


    const handleCheckDataCart = () => {
        if (sellCarts?.length === 0 && rentCarts?.length === 0) {
            return router.push('/carts');
        }
    }

    const updateData = (carts: IProductDetailPayment[]) => {
        let newCarts = [];
        for (let item of carts) {
            if (!item.checked) {
                let cItem = { ...item };
                if (item.accessories.length) {
                    let accessories: any = []
                    for (let acc of item.accessories) {
                        let find_already_accessorie = accessories?.find((e: any) => e.id === acc.id);
                        if (!find_already_accessorie) {
                            if (!acc.checked) {
                                accessories.push(acc)
                            }

                            if (item?.is_bundling || item?.is_product === false) {
                                accessories.push(acc)
                            }
                        }
                    }
                    accessories = Array.from(new Set(accessories));
                    cItem.accessories = accessories;
                }

                newCarts.push(cItem);
            }
        }

        return newCarts;
    }

    const reloadPage = () => {
        setCurrentStep(1);
        setRentCarts(updateData(rentCarts));
        setSellCarts(updateData(sellCarts));
        setRentTransportFee(0)
        setSellTransportFee(0);
    }


    return (
        <>
            <Head>
                <title>Đặt hàng thành công</title>
                <meta name="description" content="Hoài Giang Shop - Đặt hàng thành công" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <div
                style={{
                    height: '100vh',
                    position: 'relative',
                    left: 0,
                    right: 0,
                    backgroundImage: `url("../asset/image/background_cart.png")`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    overflow: 'hidden'
                }}
            >
                <DynamicLayoutPayment className="md:px-4 md:pt-4" hasFooter={false}>
                    <Spin spinning={spinLoading}>
                        {
                            (sellCarts?.length > 0 || rentCarts?.length > 0) ? (
                                <div className="" style={{ backgroundColor: ' rgba(255, 255, 255, 0.3)' }}>
                                    <div className="carts pb-6">
                                        <DynamicPaymentSuccess />
                                    </div>
                                </div>
                            ) : (
                                <div className="overflow-hidden" style={{ backgroundColor: ' rgba(255, 255, 255, 0.3)', height: 'calc(100vh - 6rem)' }} >
                                    <DynamicEmptyCart />
                                </div>
                            )
                        }
                    </Spin>

                </DynamicLayoutPayment>
            </div>
        </>
    )
}

export default OrderSuccess;
